import * as React from 'react';
import factorySvgIcon from './utils/factorySvgIcon';
const SvgBookmark = (props) => {
    const { color } = props;
    return (React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.933 16.309a2 2 0 0 1 2.134 0c1.186.748 3.466 2.114 4.933 3.057V5a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v14.366c1.466-.943 3.747-2.31 4.933-3.057ZM12 18c1.559.983 5.051 3.116 5.844 3.652 1.008.682 2.156.322 2.156-.73V4a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v16.923c0 1.05 1.148 1.41 2.156.729C6.95 21.116 10.441 18.983 12 18Z", fill: color }));
};
export default factorySvgIcon(SvgBookmark);
//# sourceMappingURL=SvgBookmark.js.map